<template>
  <div class="wt2-gallery-assets-empty-pages">
    <!-- in gallery without search -->
    <div
      v-if="isMyGallery && !hasSearch && !hasFilters"
      class="-empty-pages-box -search-no-match"
      key="uploads-no-search"
    >
      <img src="/resources/img/empty_gallery.png" />
      <span class="-title">{{ 'generic.GALLERY_EMPTY' | culture }}</span>
      <span class="-description">
        <span
          class="-upload wt2-color-primary"
          @click.prevent="$emit('open-file')"
        >
          {{ 'generic.UPLOAD' | culture }}
        </span>
        <span>
          {{ 'generic.OR_DRAG_ASSETS' | culture }}
        </span>
      </span>
    </div>
    <!-- in social -->
    <div class="-empty-pages-box" v-else-if="isSocial" key="social">
      <!-- not logged in -->
      <template v-if="isProviderNotLoggedIn">
        <div class="-connect">
          <span class="-title">
            <template v-if="revoked[searchContextId]">
              {{ 'searchMedia.disconnected' | culture }}
            </template>
            <template v-else>
              {{
                ('searchMedia.' + searchContextIdLowerCase + '.title') | culture
              }}
            </template>
          </span>
          <wt-button
            :class="'-' + searchContextIdLowerCase + '-bg'"
            :icon="'wticon-' + searchContextIdLowerCase"
            type="transparent"
            :text="'Sign in to ' + searchContextIdCapitalize"
            @click="connectSocial"
          />
        </div>
      </template>
      <!-- logged in -->
      <template v-else>
        <img
          :src="
            '/resources/img/social/' + searchContextIdLowerCase + '-grey.png'
          "
        />
        <span class="-title">
          <template v-if="!hasSearch || (isInstagram && !hasEntity)">
            {{
              ('searchMedia.' + searchContextIdLowerCase + '.search') | culture
            }}
          </template>
          <template v-else-if="isInstagram">
            {{
              ('generic.' + (hasError ? 'SEARCH_ERROR1' : 'NO_POSTS_YET'))
                | culture
            }}
          </template>
          <template v-else-if="isInstagram">
            {{
              ('generic.' + (hasError ? 'SEARCH_ERROR1' : 'NO_POSTS_YET'))
                | culture
            }}
          </template>
          <template v-else>
            {{ 'generic.NO_MATCH' | culture }}
          </template>
        </span>
        <span class="-description" v-if="hasSearch">
          <template v-if="hasError">
            <span class="wt2-color-link" @click="retry">{{
              'generic.SEARCH_ERROR2' | culture
            }}</span>
            {{ 'generic.SEARCH_ERROR3' | culture }}
          </template>
          <span v-else>{{ 'generic.TRY_ANOTHER_SEARCH' | culture }}</span>
        </span>
      </template>
    </div>

    <div
      class="-empty-pages-box -search-no-match"
      v-else-if="isFavorites && !hasSearch && !hasFilters"
      key="noMatch"
    >
      <img src="/resources/img/no_favorite_yet.png" />
      <span class="-title">
        {{ 'generic.NO_FAVORITES_YET' | culture }}
      </span>
      <span class="-description">
        {{ 'generic.NO_FAVORITES_YET_DESCRIPTION' | culture }}
      </span>
    </div>

    <div
      class="-empty-pages-box -search-no-match"
      v-else-if="isCreative && !hasSearch && !hasFilters"
      key="noMatch"
    >
      <img src="/resources/img/empty_first_time_user.png" />
      <span class="-title">
        {{ 'searchMedia.creative.title' | culture }}
      </span>
    </div>

    <div class="-empty-pages-box -search-no-match" v-else key="noMatch">
      <img src="/resources/img/empty_no_results.png" />
      <span class="-title">
        {{ 'generic.NO_MATCH' | culture }}
      </span>
      <span class="-description">
        {{
          ('generic.' +
            (isGif ? 'TRY_ANOTHER_SEARCH' : 'TRY_ANOTHER_SEARCH_OR_FILTER'))
            | culture
        }}
      </span>
    </div>
  </div>
</template>

<script>
import app from 'app';

export default {
  props: {
    searchContextId: {
      type: String,
      required: true,
    },
    hasSearch: {
      type: Boolean,
      required: true,
    },
    hasError: {
      type: Boolean,
      required: true,
    },
    hasFilters: {
      type: Boolean,
      require: true,
    },
    hasEntity: {
      type: Boolean,
      required: true,
    },
    isProviderNotLoggedIn: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      revoked: {},
    };
  },

  computed: {
    stringsArr() {
      return [
        '^2000We are fetching the relevant media for your article^2000',
        '^1700Videos are being fetched^2000.^150.^150.^1500',
        '^1000Now images are being fetched^2000.^150.^150.^1500',
        "^2000Just a few more seconds and we're done^3500",
        '^2000Finalizing media fetching^2500.^1500.^1500.^1500',
      ];
    },

    isInstagram() {
      return this.searchContextId === app.PROVIDERS.INSTAGRAM.id;
    },
    isTwitter() {
      return this.searchContextId === app.PROVIDERS.TWITTER.id;
    },
    isMyGallery() {
      return this.searchContextId === app.PROVIDERS.MY_GALLERY.id;
    },
    isGif() {
      return this.searchContextId === app.PROVIDERS.GIF.id;
    },
    isFavorites() {
      return this.searchContextId === app.PROVIDERS.FAVORITES.id;
    },
    isCreative() {
      return this.searchContextId === app.PROVIDERS.WOCHIT_CREATIVE.id;
    },
    isSocial() {
      return this.isInstagram || this.isTwitter;
    },
    searchContextIdCapitalize() {
      return _.capitalize(this.searchContextIdLowerCase);
    },
    searchContextIdLowerCase() {
      return (this.searchContextId || '').toLowerCase();
    },
  },

  methods: {
    connectSocial() {
      app.api.socialProvider
        .connect(false, this.searchContextIdLowerCase)
        .done(() => {
          this.$emit('set-provider-status');
        })
        .fail((err) => {
          if (err && err.isCanceled) {
            return;
          }
          app.dialog.error({
            type: app.dialog.types.ERROR_1,
            title: 'Action Failed',
            description: 'Could not connect to the social provider.',
            showContactCsm: true,
          });
        });
    },

    retry() {
      this.$emit('retry');
    },

    revokeSocial() {
      this.revoked[this.searchContextId] = true;
    },
  },
};
</script>
